module.exports = __webpack_public_path__ + "img/上海变频冷库.925baaf6.jpg";